export default "__VITE_ASSET__ClGxhvS0__"